import { parseColor } from "react-aria-components/ColorPicker"
import { TRANSPARENT } from "./use-color-value"

const LOCALE = "en-US"

/**
 * The color in words, such as "dark vibrant blue", so a screen reader user
 * hears more than a hex code. `undefined` for a value react-aria can't parse.
 */
export function getColorName(value: string): string | undefined {
  // react-aria doesn't parse the keyword
  if (value === TRANSPARENT) return TRANSPARENT
  try {
    const color = parseColor(value)
    if (color.getChannelValue("alpha") === 0) return TRANSPARENT
    return color.getColorName(LOCALE)
  } catch {
    return undefined
  }
}
